import {
    useCreateController,
    CreateContextProvider,
    Form,
    SaveButton,
    useNotify,
    useTranslate,
    useRefresh
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton
} from '@mui/material';

import { Resources } from '../../resource';
import ColorForm from './ColorForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateColor = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useCreateController({
        resource: Resources.color,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.color.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    
                    default:
                        notify(t('module.color.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });

    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.color.create")}</DialogTitle>
                <DialogContent>
                    <ColorForm isCreate />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="colors" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateColor;
